import { render, staticRenderFns } from "./LKMunMehCardForm.vue?vue&type=template&id=bc4d48f0&"
import script from "./LKMunMehCardForm.vue?vue&type=script&lang=js&"
export * from "./LKMunMehCardForm.vue?vue&type=script&lang=js&"
import style0 from "./LKMunMehCardForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports